<template>
    <div>
        <zm-row>
            <zm-button size="small" @click="fetchData()" type="primary" class="btn-in-line" plain>show all</zm-button>
        </zm-row>
        <div class="table-container">
            <zm-table :data="list" resizable border :row-class-name="tableRowClassName"
            v-loading="loading" :stripe="true" :init-displayed-column="initDisplayedColumn">
                <zm-table-column type="expand">
                    <template slot-scope="scope">
                        <!-- <p><b>nodes  </b>{{ scope.row.nodes.length }}</p> -->
                        <zm-table border :data="scope.row.nodes">
                            <zm-table-column label="ID" prop="id" :show-overflow-tooltip="true"></zm-table-column>
                            <zm-table-column label="Is Leader" prop="isLeader" width="100px">
                                <template slot-scope="scope">
                                    <i v-if="scope.row.isLeader" class="zm-icon-ok"></i>
                                    <i v-if="!scope.row.isLeader" class="zm-icon-close"></i>
                                </template>
                            </zm-table-column>
                            <zm-table-column label="IP" prop="ip"></zm-table-column>
                            <zm-table-column label="MAC" prop="mac"></zm-table-column>
                            <zm-table-column label="Version" prop="versionTxt" width="320px">
                                <template slot-scope="scope">
                                <zm-tooltip placement="right" v-if="scope.row.versionTxt">
                                    <div slot="content">
                                        <p v-for="(value, index) in scope.row.versionTxt" :key="index">{{ value }}</p>
                                    </div>
                                    <zm-tag size="medium" type="">{{scope.row.buildVersion}}</zm-tag>
                                </zm-tooltip>
                                <span v-else></span>
                            </template>
                            </zm-table-column>
                            <zm-table-column label="Hostname" prop="hostname"></zm-table-column>
                            <zm-table-column label="RegisterTime" prop="createdTime" :formatter="setTime"></zm-table-column>
                        </zm-table>
                        <div style="text-align: center" class="pagination-wrap">
                            <zm-pagination
                                layout="total"
                                :total="scope.row.nodes.length">
                            </zm-pagination>
                        </div>
                        <p v-if="scope.row.routers.length"><b>routers  </b>{{ scope.row.routers.length }}</p>
                        <zm-table border v-if="scope.row.routers.length" :data="scope.row.routers">
                            <zm-table-column label="Name"></zm-table-column>
                            <zm-table-column label="Zone"></zm-table-column>
                            <zm-table-column label="Active"></zm-table-column>
                            <zm-table-column label="CreatedTime"></zm-table-column>
                            <zm-table-column label="ModifiedTime"></zm-table-column>
                        </zm-table>
                        <div style="text-align: center" class="pagination-wrap" v-if="scope.row.routers.length">
                            <zm-pagination
                                layout="total"
                                :total="scope.row.routers.length">
                            </zm-pagination>
                        </div>
                    </template>
                </zm-table-column>
                <zm-table-column prop="region" label="dc" align="center">
                </zm-table-column>
                <zm-table-column prop="backup" label="backup" align="center" width="100px">
                </zm-table-column>
                <zm-table-column prop="name" label="name" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="endpoint" label="endpoint" align="center">
                </zm-table-column>
                <zm-table-column prop="dataCenterStatus" label="dataCenterStatus" align="center" width="140px">
                </zm-table-column>
                <zm-table-column prop="health" label="health" align="center">
                    <template slot-scope="scope">
                        <i v-if="scope.row.health" class="zm-icon-ok"></i>
                        <i v-if="!scope.row.health" class="zm-icon-close"></i>
                    </template>
                </zm-table-column>
                <zm-table-column prop="isOnline" label="isOnline" align="center">
                    <template slot-scope="scope">
                        <i v-if="scope.row.isOnline" class="zm-icon-ok"></i>
                        <i v-if="!scope.row.isOnline" class="zm-icon-close"></i>
                    </template>
                </zm-table-column>
                <zm-table-column prop="expectedServerNodes" label="expectedServerNodes" align="center" width="170px">
                </zm-table-column>
                <zm-table-column prop="nodes" label="nodes" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.nodes.length }}
                    </template>
                </zm-table-column>
                <zm-table-column prop="master" label="master" align="center">
                    <template slot-scope="scope">
                        <i v-if="scope.row.master" class="zm-icon-ok"></i>
                        <i v-if="!scope.row.master" class="zm-icon-close"></i>
                    </template>
                </zm-table-column>
                <zm-table-column prop="active" label="active" align="center">
                    <template slot-scope="scope">
                        <i v-if="scope.row.active" class="zm-icon-ok"></i>
                        <i v-if="!scope.row.active" class="zm-icon-close"></i>
                    </template>
                </zm-table-column>
                <zm-table-column prop="modifiedTime" label="modifiedTime" align="center" :formatter="setTime">
                </zm-table-column>
                <zm-table-column prop="createdTime" label="createdTime" align="center" :formatter="setTime">
                </zm-table-column>
                <zm-table-column prop="operate" width="160px" header-align="center" v-if="role === 'SUPER_ADMIN'">
                    <template slot-scope="scope">
                        <zm-button size="small" class="btn-contain" type="icon" title="edit dc" icon="zm-icon-edit" @click="showEdit(scope.row)"></zm-button>
                        <zm-button size="small" class="btn-contain" type="icon" title="enable dc" icon="zm-icon-play"
                        v-if="!scope.row.active" @click="activeDC(scope.row)"></zm-button>
                        <zm-button size="small" class="btn-contain" type="icon" title="disable dc" icon="zm-icon-pause"
                        v-if="scope.row.active" @click="activeDC(scope.row)"></zm-button>
                        <zm-button size="small" class="btn-contain" type="icon" title="off line dc" icon="zm-icon-delete"
                        v-if="!scope.row.active && !scope.row.nodes.length" @click="deleteDC(scope.row.name)"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
        </div>
        <zm-dialog :visible.sync="visible" title="Edit Data Center">
            <zm-form label-width="110px" label-position="left">
                <zm-form-item label="Endpoint">
                    <div slot="label">
                        <tip label="Endpoint" id="dc-endpoint"></tip>
                    </div>
                    <zm-input v-model.trim="form.endpoint" size="small"></zm-input>
                </zm-form-item>
                <zm-form-item label="Backup">
                    <div slot="label">
                        <tip label="Backup" id="dc-backup"></tip>
                    </div>
                    <zm-select v-model="form.backup" clearable size="small" style="width: 100%">
                        <zm-option v-for="item in dcs" :key="item.id" :value="item.dcName" :label="item.dcName"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="ExpectedServerNodes" label-width="180px">
                    <div slot="label">
                        <tip label="ExpectedServerNodes" id="dc-expectedServerNodes"></tip>
                    </div>
                    <zm-input-number v-model="form.expectedServerNodes" size="small"></zm-input-number>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.isOnline" size="small">
                        <tip label="isOnline" id="dc-isOnline"></tip>
                    </zm-checkbox>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save" :loading="loading">Save</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { getDc, deleteDC, getChannelDcs, updateDc, activeDC } from '../../api/index'
import tip from 'components/ToolTip/index'
export default {
    name: 'dc',
    components: { tip },
    data () {
        return {
            initDisplayedColumn: {
                key: 'dc',
                props: ['region', 'backup', 'name', 'endpoint', 'dataCenterStatus', 'health', 'isOnline', 'expectedServerNodes', 'nodes', 'master', 'active', 'modifiedTime', 'createdTime', 'operate']
            },
            list: [],
            dcs: [],
            form: {
                name: '',
                backup: '',
                expectedServerNodes: 0,
                endpoint: '',
                isOnline: false
            },
            visible: false,
            role: localStorage.role,
            loading: false
        }
    },
    created () {
        localStorage.params = ''
        localStorage.path = this.$route.path
        this.fetchData()
        this.fetchDcs()
    },
    methods: {
        setTime (row, column, cellValue, index) {
            let time = row[column.property]
            return new Date(parseInt(time)).toLocaleString()
        },
        tableRowClassName ({ row, rowIndex }) {
            if (!row.active) {
                return 'warning-row'
            }
            return ''
        },
        fetchDcs () {
            getChannelDcs().then(response => {
                this.dcs = response
            })
        },
        showEdit (row) {
            this.form.name = row.name
            this.form.backup = row.backup
            this.form.endpoint = row.endpoint
            this.form.expectedServerNodes = row.expectedServerNodes
            this.form.isOnline = row.isOnline
            this.visible = true
        },
        activeDC (row) {
            this.loading = true
            this.$confirm('This will change the status. Continue?', 'Warning', {
                confirmButtonText: 'Change',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                activeDC(row.name, !row.active).then(response => {
                    this.fetchData()
                    this.$message({
                        message: 'Change status success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Change canceled'
                })
            })
        },
        save () {
            const { name, backup, endpoint, expectedServerNodes, isOnline } = this.form
            const data = { name, backup, endpoint, expectedServerNodes, isOnline }
            this.loading = true
            // updateBackup(name, { backup }).then(response => {
                updateDc(data).then(response => {
                    this.fetchData()
                    this.visible = false
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            // }).catch(() => {
            //     this.loading = false
            // })
        },
        deleteDC (name) {
            this.$confirm('This will off line the dc. Continue?', 'Warning', {
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteDC(name).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message({
                        message: 'Off line dc success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Off line canceled'
                })
            })
        },
        fetchData () {
            this.showAllBtn = false
            this.loading = true
            getDc(true, true).then(response => {
                this.list = JSON.parse(JSON.stringify(response))
                this.list.map(item => {
                    item.isEditBackup = false
                    item.selectedBackup = item.backup || ''
                    item.bachupOptions = JSON.parse(JSON.stringify(response))
                    if (item.nodes) {
                        item.nodes.map(node => {
                            node.versionTxt = node.versionTxt.split('\r\n')
                            node.versionTxt.map(item => {
                                if (item.indexOf('Build Version:') !== -1) {
                                    node.buildVersion = item.split('Build Version:')[1]
                                }
                            })
                        })
                    }
                })
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>
<style scoped>
.btn-in-line{
    margin: 10px
}
</style>
<style>
.zm-tooltip__popper.is-light {
    word-break: break-all;
}
</style>
